export default __webpack_public_path__ + "static/media/tune.3c043c44.svg";